.styledRank {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    text-align: center;
  }
}

.styledIconRank {
  position: absolute;
  top: var(--top-position, 14%);
  font-size: var(--font-size, 14px);
}

.wrapper {
  width: var(--wrapper-size);
  height: var(--wrapper-size);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.styledPlaceholder {
  color: var(--text-soft);
  font-size: 18px;
  justify-content: center;
}
